module.exports = __webpack_public_path__ + "img/combojetvac_parked.12620ae5.svg";